import { put, call, take, fork } from 'redux-saga/effects'
import { questionListDeleteService } from '../../api/question'
import { questionListDeleteSuccess } from '../../reducers/question/action'
import { QUESTION_LIST_DELETE } from '../../reducers/question/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* questionDeleteFlow(payload) {
  try {
    const { ids, callback } = payload
    yield call(questionListDeleteService, ids)

    yield put(questionListDeleteSuccess())
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* questionDeleteListWatcher() {
  while (true) {
    const action = yield take(QUESTION_LIST_DELETE)
    const { payload } = action

    yield fork(generalSaga, questionDeleteFlow, payload)
  }
}
